import type { Fragment } from '../translations';

export const common: Fragment = {
  fr: {
    'common.loading': 'Chargement…',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.back': 'Retour',
    'common.add': 'Ajouter',
    'common.clear': 'Effacer',
    'common.remove': 'Retirer',
    'common.delete': 'Supprimer',
    'common.close': 'Fermer',
    'common.confirm': 'Confirmer',
    'common.retry': 'Réessayer',
    'common.search': 'Rechercher…',
    'common.all': 'Tous',
    'common.none': '—',
    'common.yes': 'Oui',
    'common.no': 'Non',
    'common.export': 'Exporter',
    'common.open': 'Ouvrir',
    'common.edit': 'Modifier',
    'common.readonly': 'Lecture seule',
    'common.logout': 'Déconnexion',
    'common.language': 'Langue',
    'common.theme.toDark': 'Passer en sombre',
    'common.theme.toLight': 'Passer en clair',
    'common.daysShort': 'j',
    'common.comment': 'Commenter',
    'common.send': 'Envoyer',
  },
  en: {
    'common.loading': 'Loading…',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.back': 'Back',
    'common.add': 'Add',
    'common.clear': 'Clear',
    'common.remove': 'Remove',
    'common.delete': 'Delete',
    'common.close': 'Close',
    'common.confirm': 'Confirm',
    'common.retry': 'Retry',
    'common.search': 'Search…',
    'common.all': 'All',
    'common.none': '—',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.export': 'Export',
    'common.open': 'Open',
    'common.edit': 'Edit',
    'common.readonly': 'Read only',
    'common.logout': 'Log out',
    'common.language': 'Language',
    'common.theme.toDark': 'Switch to dark',
    'common.theme.toLight': 'Switch to light',
    'common.daysShort': 'd',
    'common.comment': 'Comment',
    'common.send': 'Send',
  },
};
